export const enum MicrosEnvironmentType {
	local = 'local',
	dev = 'dev',
	staging = 'staging',
	prod = 'prod',
}

export type IcName = 'ic-dr6' | 'ic-em8';

export const isLocal = (): boolean =>
	process.env.PILLAR_LOCAL_DEVELOPMENT === 'true' ||
	process.env.FRONTEND_VERSION === 'LOCAL-local-0';

export const isStaging = (): boolean =>
	(globalThis as any).ssrContext.environmentType === MicrosEnvironmentType.staging;

export const isStagingOrLocalOrDev = (): boolean =>
	isLocal() ||
	isStaging() ||
	(globalThis as any).ssrContext.environmentType === MicrosEnvironmentType.dev;

export const getEnv = (): string => (globalThis as any).ssrContext.environment;

export const getEnvType = (): MicrosEnvironmentType =>
	(globalThis as any).ssrContext.environmentType;

export const getScriptVersion = (): string => (globalThis as any).ssrContext.entryScriptVersionId;

export function isInIC(): boolean {
	return (globalThis as any).ssrContext.isInIC === true;
}

export function isInFedramp(): boolean {
	return (globalThis as any).ssrContext?.isInFedramp === true;
}

export function getIcName(): IcName {
	return (globalThis as any).ssrContext.icName as IcName;
}

export function isInGCP(): boolean {
	return (globalThis as any).ssrContext.isInGCP === true;
}

export function getCellName(): string {
	return (globalThis as any).ssrContext.cellName;
}
